
import React from 'react';
import { siteConfig } from '../config/site';
import { Instagram, Facebook, Twitter, Youtube, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../App';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-primary pt-24 pb-12 px-6 border-t border-accent/10 overflow-hidden">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12 mb-20">
        <div className="col-span-1 md:col-span-1 space-y-6">
          <Link to="/" className="flex flex-col items-start gap-4">
            <img src={siteConfig.images.logo} alt="Santi Bladez" className="w-16 h-16 object-contain rounded-full border border-accent/20 bg-black/40" />
            <h2 className="text-xl font-serif font-bold accent-text-gradient tracking-widest uppercase">{siteConfig.brandName}</h2>
          </Link>
          <p className="text-white/40 text-sm leading-relaxed max-w-xs font-light italic">
            {t.footerDesc}
          </p>
          <div className="flex gap-4">
            <a href={siteConfig.socials.instagram} target="_blank" rel="noopener" className="text-accent/60 hover:text-accent transition-colors"><Instagram size={20} /></a>
            <a href={siteConfig.socials.facebook} target="_blank" rel="noopener" className="text-accent/60 hover:text-accent transition-colors"><Facebook size={20} /></a>
            <a href={siteConfig.socials.twitter} target="_blank" rel="noopener" className="text-accent/60 hover:text-accent transition-colors"><Twitter size={20} /></a>
            <a href={siteConfig.socials.youtube} target="_blank" rel="noopener" className="text-accent/60 hover:text-accent transition-colors"><Youtube size={20} /></a>
          </div>
        </div>

        <div>
          <h4 className="text-accent text-sm font-bold uppercase tracking-[0.3em] mb-8">{t.navTitle}</h4>
          <ul className="space-y-4 text-white/60 text-sm">
            <li><Link to="/" className="hover:text-accent transition-colors">Home</Link></li>
            <li><Link to="/brand" className="hover:text-accent transition-colors">My Story</Link></li>
            <li><Link to="/gallery" className="hover:text-accent transition-colors">Gallery</Link></li>
            <li><Link to="/#services" className="hover:text-accent transition-colors">{t.signatureHouseCall}</Link></li>
            <li><Link to="/#coverage" className="hover:text-accent transition-colors">{t.availability}</Link></li>
            <li><Link to="/#reviews" className="hover:text-accent transition-colors">{t.verifiedTestimonials}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-accent text-sm font-bold uppercase tracking-[0.3em] mb-8">{t.conciergeTitle}</h4>
          <ul className="space-y-4 text-white/60 text-sm">
            <li><Link to="/faq" className="hover:text-accent transition-colors">FAQ</Link></li>
            <li><Link to="/privacy" className="hover:text-accent transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-accent transition-colors">Terms of Service</Link></li>
            <li><a href={`tel:${siteConfig.phone}`} className="hover:text-accent transition-colors">Contact Support</a></li>
          </ul>
        </div>

        <div className="space-y-6">
          <h4 className="text-accent text-sm font-bold uppercase tracking-[0.3em] mb-8">{t.staySharp}</h4>
          <p className="text-white/40 text-sm">{t.staySharpDesc}</p>
          <div className="flex group">
            <input 
              type="email" 
              placeholder="Email"
              className="bg-secondary/50 border border-white/10 px-4 py-3 text-sm focus:outline-none focus:border-accent transition-all w-full placeholder:text-white/20"
            />
            <button className="bg-accent text-black p-3 hover:bg-accent-light transition-colors shadow-[0_0_15px_rgba(205,127,50,0.2)]">
              <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] text-white/30 font-bold uppercase tracking-widest">
        <p>&copy; {new Date().getFullYear()} {siteConfig.brandName}. All Rights Reserved.</p>
        <div className="flex gap-6">
          <span className="text-accent/50">Solo Elite Service</span>
          <span className="text-accent/50">{t.southFlorida}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
